
import { ModelBase } from "@models/UpsertableBase";
import { FeatureUserRating, PlayerObject } from "@models";
import { 
  TemplateBase,
} from "@dndModels";
import DandDAPI from "@dndUtilities/system_api";
import { DataType } from "@dndModels/Types";

const api = DandDAPI.getInstance();

export interface CardMeanings { 
  person: string,
  creature_or_trap: string,
  place: string, 
  treasure: string,
  situation: string 
}

export class GameDeck extends ModelBase {
  data_type: DataType = "game_deck";
  
  constructor(obj?: any) {
    super(obj);
    if (obj) {
      // this.drawn_effect = obj.drawn_effect ? obj.drawn_effect : "";
    }
  }

  get_homebrewery_string(): string {
    let str = `# ${this.true_name}\n\r`;
    str += `${this.description}\n\r`;
    return str;
  }

  toDBObj(): any {
    const base_db_obj = super.toDBObj();
    return {
      ...base_db_obj,
      // drawn_effect: this.drawn_effect,
    };
  }

  copy(copyMe: GameDeck, drop_ids = false): void {
    super.copy(copyMe, drop_ids);
    // this.drawn_effect = copyMe.drawn_effect;
  }

  clone(drop_ids = false): GameDeck {
    const new_obj = new GameDeck();
    new_obj.copy(this, drop_ids);
    return new_obj;
  }

  copyTemplate(copyMe: TemplateBase): void {
    this.name = copyMe.name;
    this.description = copyMe.description;
    this.source_books_old = [];
    copyMe.source_books_old.forEach(sb => {
      this.source_books_old.push({...sb});
    });
    // const obj = {...copyMe.item};
    // this.drawn_effect = obj && obj.drawn_effect ? obj.drawn_effect : "";
  }

  copy5e(copyMe: any): void {
    console.log(copyMe);
  }

  connectUserRatings(userRatings: FeatureUserRating[]) {
    
  }
}

export class GameCard extends ModelBase {
  data_type: DataType = "game_card";
  _drawn_effect = "";
  apply_gift_id = "";
  reshuffle = true;
  upright_meanings: CardMeanings = { person: "", creature_or_trap: "", place: "", treasure: "", situation: "" };
  reversed_meanings: CardMeanings = { person: "", creature_or_trap: "", place: "", treasure: "", situation: "" };
  deck_ids: string[] = [];
  beneficial = false;
  
  constructor(obj?: any) {
    super(obj);
    if (obj) {
      // if (this.name.includes("Dragon")) {
      //   debugger;
      // }
      this._drawn_effect = obj._drawn_effect ? obj._drawn_effect : "";
      if (this._drawn_effect === "" && obj.drawn_effect) {
        this.description = obj.drawn_effect;
      }
      this.apply_gift_id = obj.apply_gift_id ? obj.apply_gift_id : "";
      this.reshuffle = obj.reshuffle !== undefined ? obj.reshuffle : true;
      this.upright_meanings = obj.upright_meanings ? obj.upright_meanings : { person: "", creature_or_trap: "", place: "", treasure: "", situation: "" };
      this.reversed_meanings = obj.reversed_meanings ? obj.reversed_meanings : { person: "", creature_or_trap: "", place: "", treasure: "", situation: "" };
      this.deck_ids = obj.deck_ids ? obj.deck_ids : [];
      this.beneficial = obj.beneficial ? obj.beneficial : false;
    }
  }

  get description_format() {
    return `${this.drawn_effect}`;
  }

  // load(obj: any): void {
  //   super.load(obj);
  //   if (obj) {
  //     // if (this.name.includes("Dragon")) {
  //     //   debugger;
  //     // }
  //     this._drawn_effect = obj._drawn_effect ? obj._drawn_effect : "";
  //     if (this._drawn_effect === "" && obj.drawn_effect) {
  //       this.description = obj.drawn_effect;
  //     }
  //     this.apply_gift_id = obj.apply_gift_id ? obj.apply_gift_id : "";
  //     this.reshuffle = obj.reshuffle !== undefined ? obj.reshuffle : true;
  //     this.upright_meanings = obj.upright_meanings ? obj.upright_meanings : { person: "", creature_or_trap: "", place: "", treasure: "", situation: "" };
  //     this.reversed_meanings = obj.reversed_meanings ? obj.reversed_meanings : { person: "", creature_or_trap: "", place: "", treasure: "", situation: "" };
  //     this.deck_ids = obj.deck_ids ? obj.deck_ids : [];
  //     this.beneficial = obj.beneficial ? obj.beneficial : false;
  //   }
  // }

  get drawn_effect() {
    return this._drawn_effect === "" ? this.description : this._drawn_effect;
  }

  get_homebrewery_string(): string {
    let str = `# ${this.true_name}\n\r`;
    str += `${this.description}\n\r`;
    return str;
  }

  toDBObj(): any {
    const base_db_obj = super.toDBObj();
    return {
      ...base_db_obj,
      reshuffle: this.reshuffle,
      _drawn_effect: this._drawn_effect,
      apply_gift_id: this.apply_gift_id,
      upright_meanings: this.upright_meanings,
      reversed_meanings: this.reversed_meanings,
      deck_ids: this.deck_ids,
      beneficial: this.beneficial
    };
  }

  toLight(): any {
    const base_db_obj = super.toLight();
    return {
      ...base_db_obj,
      // reshuffle: this.reshuffle,
      // _drawn_effect: this._drawn_effect,
      // apply_gift_id: this.apply_gift_id,
      // upright_meanings: this.upright_meanings,
      // reversed_meanings: this.reversed_meanings,
      deck_ids: this.deck_ids,
      // beneficial: this.beneficial
    };
  }

  copy(copyMe: GameCard, drop_ids = false): void {
    super.copy(copyMe, drop_ids);
    this.reshuffle = copyMe.reshuffle;
    this._drawn_effect = copyMe._drawn_effect;
    this.apply_gift_id = copyMe.apply_gift_id;
    this.upright_meanings = copyMe.upright_meanings;
    this.reversed_meanings = copyMe.reversed_meanings;
    this.deck_ids = [...copyMe.deck_ids];
    this.beneficial = copyMe.beneficial;
  }

  clone(drop_ids = false): GameCard {
    const new_obj = new GameCard();
    new_obj.copy(this, drop_ids);
    return new_obj;
  }

  copyTemplate(copyMe: TemplateBase): void {
    this.name = copyMe.name;
    this.description = copyMe.description;
    this.source_books_old = [];
    copyMe.source_books_old.forEach(sb => {
      this.source_books_old.push({...sb});
    });
    const obj = {...copyMe.item};
    this._drawn_effect = obj && obj.drawn_effect ? obj.drawn_effect : "";
    this.apply_gift_id = obj && obj.apply_gift_id ? obj.apply_gift_id : "";
    this.reshuffle = obj && obj.reshuffle !== undefined ? obj.reshuffle : true;
    this.upright_meanings = obj && obj.upright_meanings ? obj.upright_meanings : "";
    this.reversed_meanings = obj && obj.reversed_meanings ? obj.reversed_meanings : "";
    // this.right_meaning = obj && obj.right_meaning ? obj.right_meaning : "";
    // this.reversed_meaning = obj && obj.reversed_meaning ? obj.reversed_meaning : "";
    this.deck_ids = obj && obj.deck_ids ? [...obj.deck_ids] : [];
  }

  copy5e(copyMe: any): void {
    console.log(copyMe);
  }

  connectUserRatings(userRatings: FeatureUserRating[]) {
    
  }
}

export class CampaignDeck extends PlayerObject {
  data_type: DataType = "campaign_deck";
  campaign_id = "";
  deck_id = "";
  card_ids: string[] = [];
  drawn_card_ids: string[] = [];
  saved_spreads: AdventureSpread[] = [];
  fudged_draw_ids: string[] = []; // This allows the DM select a particular card or set of cards to be drawn rather than the standard list.  Yes, it's cheating, but if done to make things more fun for the players then I'm okay with it.
  fudged_for_beneficial = false;

  constructor(obj?: any) {
    super(obj);
    if (obj) {
      this.campaign_id = obj.campaign_id ? obj.campaign_id : "";
      this.deck_id = obj.deck_id ? obj.deck_id : "";
      this.card_ids = obj.card_ids ? obj.card_ids : [];
      this.drawn_card_ids = obj.drawn_card_ids ? obj.drawn_card_ids : [];
      this.saved_spreads = obj.saved_spreads ? obj.saved_spreads : [];
      this.fudged_draw_ids = obj.fudged_draw_ids ? obj.fudged_draw_ids : [];
      this.fudged_for_beneficial = obj.fudged_for_beneficial ? obj.fudged_for_beneficial : false;
    }
  }

  toDBObj(): any {
    const base_db_obj = super.toDBObj();
    return {
      ...base_db_obj,
      campaign_id: this.campaign_id,
      deck_id: this.deck_id,
      card_ids: this.card_ids,
      drawn_card_ids: this.drawn_card_ids,
      saved_spreads: this.saved_spreads,
      fudged_draw_ids: this.fudged_draw_ids,
      fudged_for_beneficial: this.fudged_for_beneficial,
    };
  }

  copy(copyMe: CampaignDeck, drop_ids = false): void {
    super.copy(copyMe, drop_ids);
    this.campaign_id = copyMe.campaign_id;
    this.deck_id = copyMe.deck_id;
    this.card_ids = [...copyMe.card_ids];
    this.drawn_card_ids = [...copyMe.drawn_card_ids];
    this.saved_spreads = copyMe.saved_spreads.map(o => { 
      return { id: o.id, spread: o.spread };
    });
    this.fudged_draw_ids = [...copyMe.fudged_draw_ids];
    this.fudged_for_beneficial = copyMe.fudged_for_beneficial;
  }

  clone(drop_ids = false): CampaignDeck {
    const new_obj = new CampaignDeck();
    new_obj.copy(this, drop_ids);
    return new_obj;
  }
}

export interface AdventureSpread { 
  id: string, 
  spread: string[] 
}
